<template>
    <div id="odp">
     <div class="dokpz">
        <div class="title">{{ title }}</div>
	<div class="items">
		<div id='container' class='e-resizable'>
     		<ejs-grid ref="grid" :dataSource="data" :allowPaging="false" :pageSettings="pageSettings" :allowSorting="true" :allowGrouping="false" :selectionSettings="selectionOptions" :rowSelected="rowSelected" :rowDeselected="rowSelected" height="100%" width="100%">  
			<e-columns>
				<e-column field='ID_ARTYKULU' headerText='ID' :visible="false"></e-column>
				<e-column field='nazwaArtykulu' headerText='Nazwa artykułu' width='200'></e-column>
				<e-column field='jednostkaMiary' headerText='Jednostka miary' width='150'></e-column>
				<e-column field='OPIS' headerText='Opis' width='100'></e-column>
            			<!--<e-column type='checkbox' width='50'></e-column>-->
			</e-columns>
		</ejs-grid>
		</div>
	</div>
     </div>
     <div class="wleft">
        <button class="wlabel"> WRÓĆ </button>
     </div>
     <div class="wright dodaj_opak">
	<button class="wlabel"> WYBIERZ DOKUMENTY </button>
     </div>
    </div>
</template>

<script>

import Vue from "vue";
import { GridPlugin, Page, Sort, Filter, Group } from "@syncfusion/ej2-vue-grids";
import { odpady_dane } from "./odpady_dane.js";
import * as CONFIG from "./config.js";
import axios from "axios";
import Storage from "./Storage";

axios.defaults.withCredentials = false;

Vue.use(GridPlugin);

export default {
  name: "dokumentypz",
  props: {
    groupTitle: String,
    dataLoading: Boolean,
  },
  data: () => ({
	//data: odpady_dane.items,
	data: [],
	url: "/agent/GALEK.Magazyn/GetOdpady",
	title: "ODSORTY > ZLECENIA > ODSORTY",
	x: 1,
        pageSettings: { pageSize: 5 },
        selectionOptions: { allowColumnSelection: false, type: 'Single' },
	gitem: {},
	jwt: "",
        id_zlecenia: -1,
   }),
   provide: {
	grid: [Page, Sort, Filter, Group]
   },
   methods: { 
	rowSelected(args) {
                let selectedrecords = this.$refs.grid.getSelectedRecords();  // Get the selected records.
                if (selectedrecords.length > 0) {
                        this.gitem = selectedrecords[0];                
                        //alert(JSON.stringify(this.gitem));
                } else {
                        this.gitem = {};
                }
        },
	dodajopakclick() {
		//alert("Dodaj opakowanie");
		if (this.gitem && this.gitem.ID_ARTYKULU) {
                        this.$router.push({ path: "/odpadypz?prev=odpady&id_zlecenia=" + this.id_zlecenia + "&id_odpadu=" + this.gitem.ID_ARTYKULU});
                } else {
                        alert("Nie wybrano elementu z odpadem. Proszę zaznaczyć dokładnie 1 element z listy.");
                }
	},
	wrocclick() {
		this.$router.push({ path: "/zleceniaodpady" });
	},
	getData() {
                return axios
                        .get(CONFIG.API_URL + this.url + "/" + this.id_zlecenia, {
                        headers: {
                                "Content-Type": "application/x-www-form-urlencoded",
                                "Accept": "application/json",
				"Authorization": "Bearer " +  this.jwt,
                        }
                        })
                        .then(response => {
                                return response.data;
                        })
                        .catch(e => {
                                alert("ERROR" + e);
                        });
        },
   },
   mounted() {
        var params = this.$route.query;
        if (params["id_zlecenia"]) {
                this.id_zlecenia = params["id_zlecenia"];
        }
	var that = this;
	Storage.loadJWT("jwt").then(resp => {
                that.jwt = resp.access_token;
                that.getData().then(data => {
                        that.data = data;
                });
        });
	document.querySelector(".wright").addEventListener('click', function() { that.dodajopakclick(); } );
	document.querySelector(".wleft").addEventListener('click', function() { that.wrocclick(); } );
   }
};

</script>

<style>
  @import "../../node_modules/@syncfusion/ej2-vue-grids/styles/material.css";

.e-resizable {
  resize: both;
  overflow: auto;
  /*border: 1px solid red;*/
  padding: 1px;
  height: 500px;
  min-height: 550px;
  min-width: 250px;
}
.dodaj_opak {
	width: 100px;
	height: 50px;
	padding-top: 10px;
	text-align: right;
	float: right;
}
.title {
        text-align: left;
        width: 50%;
}
.items {
        float:none;
}
.dokpz {
        float: left;
        width: 96%;
        padding: 2% 2% 0% 2%;
}
.wright {
        width: 200px;
        height: 50px;
        position:fixed;
        bottom: 10px;
        right: 10px;
        text-align: right;
        background-color: #FFFFFF;
        /*padding-top: 10px;*/
        float: right;
        margin-top: 40px;
}
.wleft {
        width: 200px;
        height: 50px;
        position:fixed;
        bottom: 10px;
        text-align: left;
        background-color: #FFFFFF;
        float: left;
        margin-top: 40px;
        /*margin-left: 400px;*/
}
.wlabel {
        width: 200px;
        height: 50px;
        position:relative;
        background-color: #FFFFFF;
}
</style>



// WEBPACK FOOTER //
// src/components/Odpady.vue